import { FC, useEffect, useState } from 'react'
import Pagination from '../../components/Pagination';
import { useHistory } from 'react-router-dom';
import { useConfirmAction } from '../../../hooks/utils/useConfirmAction';
import { handleImageErrorGray } from '../../../utils/UtilsFiles';
import SVG from 'react-inlinesvg'
import { DeclineModal } from './modals/DeclineModal';
import { DetailModal } from './modals/DetailModal';
import { AcceptModal } from './modals/AcceptModal';
import { getMyIntroductions } from '../../../services/introductionService';
import { formatDateShortIntl2 } from '../../../helpers/FormatDate';
import { IntroductionRequest, IntroductionRequestList } from '../models';

interface PropsSectionRequest {
}

const SectionRequest: FC<PropsSectionRequest> = ({ }) => {
    const [paginationData, setPaginationData] = useState<any>(null);
    const [list, setList] = useState<IntroductionRequestList>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    // modal declinar
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showAcceptModal, setShowAcceptModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState<IntroductionRequest>();
    const limit = 10;
    const history = useHistory()
    const confirm = useConfirmAction()

    useEffect(() => {
        getList();
    },[])

    const getList = async (page:number=1,offset:number=0) => {
        setIsLoading(true);
        const introductions_ = await getMyIntroductions({ section: 'request', limit, offset })
        setPaginationData(introductions_);
        setList(introductions_?.results || []);
        setCurrentPage(page);
        setIsLoading(false);
    }

    const totalPages = paginationData
        ? Math.ceil(paginationData.count / limit)
        : 1;

    const handlePageChange = async (page: number) => {
        const offset = (page - 1) * limit;
        await getList(page,offset);
    };

    const handleReject = async (introduction:IntroductionRequest) => {
        setSelectedItem(introduction);
        setShowDeclineModal(true)
    }

    const handleAccept = async (introduction:IntroductionRequest) => {
        setSelectedItem(introduction);
        setShowAcceptModal(true)
    }

    const handleShowDetail = (introduction:IntroductionRequest) => {
        setSelectedItem(introduction);
        setShowDetailModal(true)
    }

    return (
        <div className="tap-host-secction-experiences-past-wrapper">
            <div className={`tap-host-secction-experiences-past-list ${isLoading ? '' : 'd-none'}`}>
                <div className='loader-experience'></div>
            </div>
            <div className={`introductions-secction-wrapper-list`}>
                {(list ?? []).map((intro:IntroductionRequest, index:number) =>
                    (<div key={intro.id ?? index} className="introductions-card">

                        {/* LEFT IMAGE */}
                        <div className="introductions-card-img-wrapper cursor-pointer" onClick={()=>handleShowDetail(intro)}>
                            <img className="introductions-card-img" src={intro?.relation == "receiver" ? intro?.requester?.avatar : intro?.recipent?.avatar} onError={handleImageErrorGray} alt={intro?.requester?.username}/>

                            <div className="introductions-card-img-overlay">
                                <div className="introductions-card-img-title">
                                    {intro?.relation == "receiver" ?  intro?.requester?.username : intro?.recipent?.username }
                                </div>
                            </div>
                        </div>

                        {/* RIGHT CONTENT */}
                        <div className="introductions-card-details">

                            {/* HEADER */}
                            <div className="introductions-card-header">
                                <div className="introductions-card-header-left">
                                    <div className="introductions-card-header-label">Type</div>
                                    <div className="introductions-card-header-value">{ intro?.type || 'General Introduction' }</div>
                                </div>
                                <div className="introductions-card-header-right">
                                    <div className="introductions-card-header-date">{ formatDateShortIntl2(intro?.dateRequest) }</div>
                                    {intro?.dateExpires && (
                                        <div className="introductions-card-header-expiry">
                                            <SVG src="/media/svg/nobilis/clock.svg" />
                                            <span>{ intro?.dateExpires }</span>
                                            <SVG src="/media/svg/nobilis/info.svg" className="cursor-pointer" />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* INFO BOX */}
                            <div className="introductions-card-info-box">
                                <div className="introductions-card-info-row">
                                    <div className="introductions-card-info-label">
                                        TOPIC
                                    </div>
                                    <div className="introductions-card-info-value">
                                        {intro.topic || 'N/A'}
                                    </div>
                                </div>
                                <div className="introductions-card-info-divider"></div>
                                <div className="introductions-card-info-row">
                                    <div className="introductions-card-info-label">
                                        MESSAGE
                                    </div>
                                    <div className="introductions-card-info-content">
                                        <div className="introductions-card-info-value text-truncate-introduction">
                                            { intro.message || 'N/A' }
                                        </div>
                                        {intro?.message && intro.message.length > 120 && (
                                            <div className="introductions-card-read-more" onClick={()=>handleShowDetail(intro)}>
                                                READ MORE
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* BOTTOM ACTIONS */}
                            <div className="introductions-card-actions">
                                <div role='button' onClick={() => handleReject(intro)} className="tap-add-experience-2-btn-secondary">
                                    Reject
                                </div>
                                <div role='button' onClick={() => handleAccept(intro)} className="tap-add-experience-2-btn-main tap-flex-center">
                                    <div className='tap-host-button-text tap-flex-center'>
                                        Accept &nbsp;<SVG src='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)
                )}
            </div>
            {list.length > 0 && paginationData && (<div className='text-start mt-5'>
                <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
            </div>)}
            {list.length == 0 && (<div className="no-introductions">
                There is no introductions activity yet.
            </div>)}
            {showDetailModal && (<DetailModal introduction={selectedItem} open={showDetailModal} onCancel={()=>setShowDetailModal(false)} />)}
            {showDeclineModal && (<DeclineModal introduction={selectedItem} open={showDeclineModal} onCancel={()=>setShowDeclineModal(false)} onComplete={getList} />)}
            {showAcceptModal && (<AcceptModal introduction={selectedItem} open={showAcceptModal} onCancel={()=>setShowAcceptModal(false)} onComplete={getList} />)}
        </div>

    )
}

export { SectionRequest }